import { render } from "./AposCheckbox.vue?vue&type=template&id=154fb6be&scoped=true"
import script from "./AposCheckbox.vue?vue&type=script&lang=js"
export * from "./AposCheckbox.vue?vue&type=script&lang=js"

import "./AposCheckbox.vue?vue&type=style&index=0&id=154fb6be&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154fb6be"],['__file',"ui/ui/apos/components/AposCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "154fb6be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('154fb6be', __exports__)) {
    api.reload('154fb6be', __exports__)
  }
  
  module.hot.accept("./AposCheckbox.vue?vue&type=template&id=154fb6be&scoped=true", () => {
    api.rerender('154fb6be', render)
  })

}


export default __exports__